import React from 'react';
import { CheckCircle2, Target, Lightbulb, Award } from 'lucide-react';
import { companyInfo } from '../mock';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { language } = useLanguage();
  const values = [
    {
      icon: Target,
      titleId: "Fokus pada Solusi",
      titleEn: "Solution Focused",
      descriptionId: "Menghadirkan solusi IT terintegrasi yang sesuai dengan kebutuhan bisnis Anda",
      descriptionEn: "Provide integrated IT solutions that suit your business needs"
    },
    {
      icon: Lightbulb,
      titleId: "Inovasi Berkelanjutan",
      titleEn: "Continuous Innovation",
      descriptionId: "Selalu mengadopsi teknologi terkini untuk memberikan nilai maksimal",
      descriptionEn: "Always adopt the latest technology to provide maximum value"
    },
    {
      icon: Award,
      titleId: "Kualitas Terjamin",
      titleEn: "Guaranteed Quality",
      descriptionId: "Berkomitmen memberikan layanan berkualitas tinggi dengan standar internasional",
      descriptionEn: "Committed to providing high-quality services with international standards"
    },
    {
      icon: CheckCircle2,
      titleId: "Partner Terpercaya",
      titleEn: "Trusted Partner",
      descriptionId: "Dipercaya oleh pemerintah dan perusahaan besar di Indonesia",
      descriptionEn: "Trusted by government and large companies in Indonesia"
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-[1.15]">
              {language === 'id' ? 'System Integrator' : 'Trusted System'}
              <span className="block bg-gradient-to-r from-yellow-600 to-red-600 bg-clip-text text-transparent pb-2 leading-[1.15]">
                {language === 'id' ? 'Terpercaya' : 'Integrator'}
              </span>
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              <span className="font-bold text-gray-900">{companyInfo.fullName}</span> ({language === 'id' ? 'Saleno' : 'Seleno'}) {language === 'id' ? 'adalah perusahaan System Integrator yang berdiri sejak 2020' : 'is a System Integrator established in 2020'}. {language === 'id' ? 'Kami menyediakan solusi ' : 'We provide '}
              <span className="font-bold text-gray-900">{language === 'id' ? 'IT Security, Networking, Infrastructure, Cloud, dan Database Management' : 'IT Security, Networking, Infrastructure, Cloud, and Database Management'}</span>
              {language === 'id' ? ' berbasis teknologi terkini.' : ' solutions based on the latest technology.'}
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {language === 'id'
                ? 'Kami membantu bisnis membangun ekosistem digital yang aman dan andal melalui layanan terintegrasi, mulai dari perancangan, implementasi, hingga dukungan berkelanjutan. Didukung tim profesional dan mitra teknologi global, Saleno hadir sebagai partner teknologi terpercaya dalam mendukung transformasi digital klien.'
                : 'We empower businesses to build secure and reliable digital ecosystems through fully integrated services—from strategic design and implementation to ongoing technical support. Backed by a team of certified professionals and global technology partners, Seleno stands as a trusted technology partner dedicated to driving our client\'s digital transformation.'
              }
            </p>
          </div>

          {/* Right Content - Values Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              const title = language === 'id' ? value.titleId : value.titleEn;
              const description = language === 'id' ? value.descriptionId : value.descriptionEn;
              return (
                <div 
                  key={index}
                  className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 hover:shadow-xl hover:border-yellow-200 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-50 to-red-100 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="text-yellow-600" size={24} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
